export enum ClientInstallationStatus {
  Installed = "installed",
  PendingUninstall = "pendingUninstall",
  Uninstalled = "uninstalled",
}
